/*=========================================================================================
  File Name: module-usertax.js
  Description: UserTax Module
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-inbox-state';
import mutations from './module-inbox-mutations';
import actions from './module-inbox-actions';
import getters from './module-inbox-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
